import { NAV_REGISTRY } from 'src/config/navigation.registry';
import {
    getOverviewNavForAgencyType,
    getSettingsNavForAgencyType,
    getRestrictedRoutePrefixesForAgencyType,
} from 'src/config/navigation.utils';
import { NAV_SECTIONS } from 'src/config/navigation.constants';
import { AGENCY_TYPES } from 'src/constants/roles.constants';
import { getEnvFeatureFlagDefaults } from 'src/config/featureFlags';
import { isFeatureFlagEnabled } from 'src/store/feature-flags/feature-flags.utils';

// Sidebar dimension constants
export const SIDEBAR_WIDTH_EXPANDED = 240;
export const SIDEBAR_WIDTH_COLLAPSED = 42;

/**
 * Legacy exports — derived from the navigation registry so sidebar and routes
 * stay in sync. Prefer `sidebarNavSelector` in new code.
 */
export const primaryData = getOverviewNavForAgencyType(NAV_REGISTRY, null);

export const evpPrimaryData = getOverviewNavForAgencyType(NAV_REGISTRY, AGENCY_TYPES.EMERGENCY);

export const EVP_RESTRICTED_ROUTE_PREFIXES = getRestrictedRoutePrefixesForAgencyType(
    NAV_REGISTRY,
    AGENCY_TYPES.EMERGENCY,
);

export const getPrimaryDataForAgencyType = (agencyType) =>
    getOverviewNavForAgencyType(NAV_REGISTRY, agencyType);

export const secondaryData = [];

export const teamData = NAV_REGISTRY
    .filter((entry) => entry.nav?.section === NAV_SECTIONS.TEAM_MANAGEMENT && entry.nav?.audience === 'all')
    .map((entry) => ({
        title: entry.nav.title,
        key: entry.nav.key,
        href: entry.navPath,
        iconName: entry.nav.iconName,
    }));

export const adminOnlyData = NAV_REGISTRY
    .filter((entry) => entry.id === 'requests')
    .map((entry) => ({
        title: entry.nav.title,
        key: entry.nav.key,
        href: entry.navPath,
        iconName: entry.nav.iconName,
    }));

export const lytInternalData = NAV_REGISTRY
    .filter((entry) => entry.nav?.section === NAV_SECTIONS.INTERNAL_TOOLS)
    .map((entry) => ({
        title: entry.nav.title,
        key: entry.nav.key,
        href: entry.navPath,
        iconName: entry.nav.iconName,
        ...(entry.nav.noIconColor ? { noIconColor: true } : {}),
    }));

export const adminData = [...teamData, ...adminOnlyData];

export const settingsData = NAV_REGISTRY
    .filter((entry) => entry.nav?.section === NAV_SECTIONS.SETTINGS)
    .filter((entry) => isFeatureFlagEnabled(getEnvFeatureFlagDefaults(), entry.featureFlag))
    .map((entry) => ({
        title: entry.nav.title,
        key: entry.nav.key,
        href: entry.navPath,
        iconName: entry.nav.iconName,
    }));

export const getSettingsDataForAgencyType = (agencyType) =>
    getSettingsNavForAgencyType(NAV_REGISTRY, agencyType);
